export default "__VITE_ASSET__CNn2ZNN3__"